import ActionsForm from '@/shared/mixins/actionsForm'
import RequestsRepository from '@/shared/http/repositories/realestate/requestRepository'
import { loading } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  mixins: [ActionsForm],
  name: 'tableRequests',
  data () {
    return {
      requests: [],
      selectedSolicitacao: {},
      title: 'Buscar por Solicitações'
    }
  },
  methods: {
    onLoad () {
      if (localStoreHelper.solicitacoes.solicitacoes() !== null) {
        this.searchWithFilter(localStoreHelper.solicitacoes.solicitacoes(), true)
      }
      loading.push()
      if (this.isFilter) {
        RequestsRepository.GetFiltro(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.filter)
          .then(res => {
            if (res.status === 200) {
              loading.pop()
              let newRequestsArray = res.data.data
              let newResponse = res
              this.requests = newRequestsArray
              this.$refs.tableGrid.LoadAllByData(newResponse)
            }
          })
          .catch(Error => loading.pop())
      } else {
        RequestsRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(response => {
            loading.pop()
            this.requests = response.data.data
            this.$refs.tableGrid.LoadAllByData(response)
          })
          .catch(Error => loading.pop())
      }
    },
    searchWithFilter (filter, isFilter) {
      this.isFilter = isFilter
      this.filter = filter
      if (!this.isFilter) {
        this.$refs.tableGrid.pagingIndex = 1
        this.$refs.tableGrid.currentPage = 1
      }
      RequestsRepository.GetFiltro(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, filter)
        .then(res => {
          if (res.status === 200) {
            let newRequestsArray = res.data.data
            let newResponse = res
            this.requests = newRequestsArray
            this.$refs.tableGrid.LoadAllByData(newResponse)
          }
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/requests/components/tableRequests/tableRequests.js